import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsLicenseCreation from "../creation-inner-pages/tms-license-creation";
import TmsCreatedLicenseList from "../created-inner-pages/license-created-list";
const LicenseCreation = () => {
  const [visible, setVisible] = useState(false);
  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New License Creation
        </Button>
      </Row>
      <br />
      {!visible && <TmsCreatedLicenseList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"License Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsLicenseCreation setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default LicenseCreation;
